// extracted by mini-css-extract-plugin
export default {"shareButton":"a81cec47f45d"};